function showCheckMark(event: PointerEvent | MouseEvent) {
	// Get mouse position - center horizontally and place above cursor
	const x = event.clientX
	const y = event.clientY - 57

	// Create clipboard icon container
	const copyIcon = document.createElement("div")
	copyIcon.innerHTML = `
		<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="8" y="2" width="8" height="4" rx="1" stroke="currentColor" stroke-width="2"/>
			<path d="M8 4H6C4.89543 4 4 4.89543 4 6V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V6C20 4.89543 19.1046 4 18 4H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
			<path d="M9 13L11 15L15 11" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		</svg>
	`
	copyIcon.style.cssText = `
		position: fixed;
		left: ${x}px;
		top: ${y}px;
		font-size: 20px;
		color: #2196F3;
		border: 1px solid #2196F3;
		font-weight: bold;
		pointer-events: none;
		z-index: 9999;
		background: rgba(33, 150, 243, 0.12);
		border-radius: 50%;
		width: 44px;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		animation: copyIconAnimation 0.8s ease-out forwards;
		box-shadow: 0 2px 8px rgba(33, 150, 243, 0.2);
	`

	// Add CSS animation if not already present
	if (!document.getElementById("copy-icon-style")) {
		const style = document.createElement("style")
		style.id = "copy-icon-style"
		style.textContent = `
			@keyframes copyIconAnimation {
				0% {
					transform: translateX(-50%) scale(0.5) translateY(0);
					opacity: 0;
				}
				30% {
					transform: translateX(-50%) scale(1.1) translateY(-5px);
					opacity: 1;
				}
				60% {
					transform: translateX(-50%) scale(1) translateY(-10px);
					opacity: 1;
				}
				100% {
					transform: translateX(-50%) scale(0.8) translateY(-15px);
					opacity: 0;
				}
			}
		`
		document.head.appendChild(style)
	}

	// Add to document
	document.body.appendChild(copyIcon)

	// Remove after animation completes
	setTimeout(() => {
		copyIcon.remove()
	}, 800)
}

export const useCopyToClipboard = async (event: PointerEvent | MouseEvent, text: string) => {
	if (!text) return
	try {
		await navigator.clipboard.writeText(text)
		showCheckMark(event)
	} catch (err) {
		console.error("Failed to copy:", err)
	}
}
